import React, { Component } from 'react'

import './Hamburger.css'

const Hamburger = (props) =>{
    return(
      <div className="Hamburger" onClick={props.handleHamburger}>
        <div className="Hamburgeritem"></div>
        <div className="Hamburgeritem"></div>
        <div className="Hamburgeritem"></div>
        <div className="Hamburgeritem"></div>
        <div className="Hamburgeritem"></div>
        <div className="Hamburgeritem"></div>
      </div>
    )  
}

export default Hamburger


// WEBPACK FOOTER //
// ./src/components/Hamburger/Hamburger.js